import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { DomSanitizer } from '@angular/platform-browser';
// Services
import { BlogService } from '../../services/blog.service';
import { ModuleService } from '../../services/modules.service';
import { GlobalFlagsService } from '../../services/global-flags.service';

// Mockup
import { IoBlogMockup } from './io-blog.mockup';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-io-blog',
  templateUrl: './io-blog.component.html',
  styleUrls: ['./io-blog.component.scss']
})
export class IoBlogComponent implements OnInit, OnDestroy {

  id: any;
  blog = null;

  isLoadingBlog = null;
  numbers;

  private sub: any;

  constructor(private route: ActivatedRoute,
    private storage: LocalStorageService,
    private router: Router,
    private moduleService: ModuleService,
    private sanitizer: DomSanitizer,
    private globalFlagsService: GlobalFlagsService,
    private blogService: BlogService) {

    this.numbers = Array(8).fill(0).map((x, i) => i);

  }

  get isBlogsAvailable() {
    return this.moduleService.isBlogAvailable();
  }

  get getDefaultImg() {
    return null;
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number
      this.blog = IoBlogMockup.blog;
      this.isLoadingBlog = true;
      this.getBlog(this.id);
    });
  }

  ngOnDestroy() {
    this.globalFlagsService.setFormName('');
  }

  getImgUrl(id: any) {
    return `${environment.url.onlineResourcesStaticUrl}${id}.jpg`;
  }

  imgError(e) {
    //why is this empty?
  }

  async getBlog(id: any) {

    this.isLoadingBlog = true;
    const obj = {
      id: id
    };
    const blogCache = this.storage.retrieve(`blog${id}`);
    if (!blogCache) {
      const blog = await this.blogService.getBlog(obj);
//       blog
//         .subscribe(
//         () => {
          this.storage.store(`blog${blog.blogId}`, blog);
          this.blog = blog;
          this.globalFlagsService.setFormName(this.blog.name);
          this.isLoadingBlog = false;
//         },
//         err => {
//           this.router.navigate(['/error']);
//           throw err;
//         }
//         );
    } else {
      this.isLoadingBlog = false;
      this.blog = blogCache;
      this.globalFlagsService.setFormName(this.blog.name);
      this.blogService.incrementView(obj);
    }
  }

}
